export default {
    env: "prod",
    lob_list: ['POSTPAID'],
    parentOrigin: "https://www.airtel.in/help/",
    baseUrlWithoutAuth: "https://www.airtel.in/chatbot/",
    baseUrlWithAuth: "https://www.airtel.in/s/chatbot/",
    botTypeBaseUrl: {
        POSTPAID: "postpaid/chatMediator",
        PREPAID: "prepaid/chatMediator",
        PAYMENTSBANK: "paymentsbank/chatMediator",
        SIEBEL: "siebel/chatMediator"
    },
    monthlyPlanNewAppContext: {
        'WEB': 'https://www.airtel.in/s/selfcare/postpaid/{mobile}/planAndService?action=updateRental&planCode={code}',
        'ANDROID': 'myairtel://myplan?icpf=true&siNumber={mobile}&data={code}&source=chatbot&uri=myairtel://chat/?au=https://www.airtel.in/help/chat/?icpf=true&siNumber={mobile}&data={code}',
        'IOS': 'myairtel://change_myplan?n={mobile}&billplancode={code}&source=chatbot&uri=myairtel://webview/?ax=https://www.airtel.in/help/chat/?n={mobile}&billplancode={code}'
    },
    monthlyPlan: {
        'WEB': 'https://www.airtel.in/s/selfcare/postpaid/{mobile}/planAndService?action=updateRental&planCode={code}',
        'ANDROID': 'myairtel://myplan?icpf=true&siNumber={mobile}&data={code}',
        'IOS': 'myairtel://change_myplan?n={mobile}&billplancode={code}'
    },
    planRental: {
        'WEB': 'https://www.airtel.in/s/selfcare/postpaid/si/planAndService?action=viewservices',
        'ANDROID': 'myairtel://myplan?siNumber={mobile}',
        'IOS': 'myairtel://change_myplan?n={mobile}'
    },
    duplicateBills: {
        'ANDROID': 'myairtel://account?n={mobile}&p=AccPosBilCon&sec=AccPosBilSum',
        'IOS': 'myairtel://account?p=bill_detail&n={mobile}'
    },
    irPackTnc: 'https://s3.ap-south-1.amazonaws.com/airtel-cms/bsy/iportal/images/TnC-International-Roaming.pdf',
    irPackStandardCharges: 'https://s3.ap-south-1.amazonaws.com/airtel-cms/bsy/iportal/images/Prepaid-and-Postpaid-Website-Rate-Dump-Internaional-Roaming.pdf',
    forbiddenHTMLTags: ['applet', 'base', 'basefont', 'command', 'embed', 'frame', 'frameset', 'iframe', 'keygen', 'link', 'meta', 'noframes', 'noscript', 'object', 'param', 'script', 'title']
};


// WEBPACK FOOTER //
// ./src/config/config.prod.js